export default __webpack_public_path__ + "static/media/beats-health.3c7aa287.png";